import React from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-32 pb-24">
        <div className="max-w-[900px] mx-auto px-6">
          <h1 className="text-4xl font-bold text-[#0A1628] mb-8">
            Gizlilik Politikası
          </h1>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                1. Giriş
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Bu gizlilik politikası, web sitemizi ziyaret ettiğinizde toplanan kişisel bilgilerinizin nasıl kullanıldığını ve korunduğunu açıklamaktadır.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                2. Toplanan Bilgiler
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Web sitemizi kullanırken aşağıdaki bilgileri toplayabiliriz:
              </p>
              <ul className="list-disc list-inside text-[#6B7A90] space-y-2 ml-4">
                <li>Ad ve iletişim bilgileri</li>
                <li>E-posta adresi</li>
                <li>Telefon numarası</li>
                <li>İlgi alanlarınız ve tercihleriniz</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                3. Bilgilerin Kullanımı
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Topladığımız bilgileri şu amaçlarla kullanırız:
              </p>
              <ul className="list-disc list-inside text-[#6B7A90] space-y-2 ml-4">
                <li>Hizmetlerimizi sağlamak ve geliştirmek</li>
                <li>Müşteri desteği sunmak</li>
                <li>Size özel teklifler göndermek</li>
                <li>Yasal yükümlülüklerimizi yerine getirmek</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                4. Bilgi Güvenliği
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Kişisel bilgilerinizin güvenliğini sağlamak için uygun teknik ve organizasyonel önlemler alıyoruz.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-[#0A1628] mb-4">
                5. İletişim
              </h2>
              <p className="text-[#6B7A90] leading-relaxed mb-4">
                Gizlilik politikamız hakkında sorularınız varsa, lütfen bizimle iletişime geçin:
              </p>
              <p className="text-[#6B7A90] leading-relaxed">
                E-posta: info@agency.com<br />
                Telefon: +90 532 123 4567
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;